import {
  OverallBalance,
  ROIChart,
  StatCardsRow,
  MarketingReport,
  PaymentMethods,
} from "@/modules";
import { PageHeader } from "@/shared/ui/PageHeader";
import { useTranslation } from "@/shared/providers/LanguageProvider";

export function CrmDashboard() {
  const { t } = useTranslation();

  return (
    <div className="space-y-5">
      <PageHeader title={t.crm.pageTitle} description={t.crm.pageDescription} />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3 md:gap-5">
        <OverallBalance />
        <ROIChart />
        <StatCardsRow />
        <MarketingReport />
        <PaymentMethods />
      </div>
    </div>
  );
}
